import { Suspense, lazy } from 'react';

import { useAuth } from '../contexts/AuthContext';

const AuthenticatedRoutes = lazy(() => import('./AuthenticatedRoutes'));
const UnauthenticatedRoutes = lazy(() => import('./UnauthenticatedRoutes'));

export default () => {
  const { user, authError } = useAuth();
  return (
    <Suspense fallback={<p />}>
      {user ? (
        <AuthenticatedRoutes user={user} />
      ) : (
        <UnauthenticatedRoutes authError={authError} />
      )}
    </Suspense>
  );
};
